import { Grid } from "@mui/material";
import styles from "./styles.module.css";

function WarningMsg({ title, message }) {
  return (
    <Grid className={styles.contentWrapper} rowGap={2}>
      <Grid>
        <h2 style={{ textTransform: "capitalize" }}>{title}</h2>
      </Grid>
      <Grid>
        <h4 style={{ color: "#8b8b8b" }}>{message}</h4>
      </Grid>
    </Grid>
  );
}

export default WarningMsg;
